import './Titulo.css'

function Titulo({backgroundImage, title, position}) {
    
  return (
    <div className="title-section" style={{ '--background-image': `url(${backgroundImage})`, 
    '--background-position':`${position}` }}>
      <h1 className="title">
          <span> {title} </span>
      </h1>
    </div>
  )
}

export default Titulo
